export const AppItemMock = {
	id: '1',
	title: 'Ёжики',
	description: 'Ёжики - это психологическая, словесная ролевая игра! Вспомните себя студентом, когда вы играли в крокодил (ассоциации) и карточную мафию! Чат детектив знакомства карты mafia.',
	genres: [
		{
			'name': 'ролевая',
			'id': 'roleplay-games',
			'admin_genre': 0,
		},
		{
			'name': 'стратегия',
			'id': 'strategy-games',
			'admin_genre': 1,
		},
	],
	installs: '10 100',
	rating: 4.57,
	voters: 1234,
	image: 'https://filed9-21.my.mail.ru/pic?url=https%3A%2F%2Fcontent-28.foto.my.mail.ru%2Fcorp%2Fapp-pic-history%2F_myapps%2Fs-162148.png&sigs=636044b18440806c1efa1b69292bd284',
	// image: 'https://content-12.foto.my.mail.ru/corp/app-pic-history/_myapps/s-161116.jpg',
	communityUrl: 'google.ru',
	isFake: false,
	currentUserStore: {
		currentUser: {
			isMyCreated: true,
		},
	},
};
